import * as d3 from "d3";

import {
  CardBody,
 // CardBodyAddNew,
  CardBodyOutline,
  CardImage,
  LinkBreakIconWrapper,
  MiniTree, PencilIcon, 
  PlusIcon,
  PathIcon,
  CrossIcon
} from "./Card.Elements.js"
import { cardChangeMain, cardEdit, cardShowHideRels } from "../../handlers/cardMethods.js"
import { isAllRelativeDisplayed } from "../../handlers/general.js"
import { post } from  './../../../service/apiService'
import {toggleAllRels, toggleRels} from "../../CalculateTree/CalculateTree.handlers.js"
import {mainToMiddle} from "./../View.handlers.js"
import path_tracker from '../../../assets/images/path_tracker.png';
import {API_BASE_URL} from '../../../../src/constants.js'
import axiosInstance from "../../../axios.js"
import edit from "../../../../src/assets/images/edit.png"
import rearrange from "../../../../src/assets/images/rearrange.png"

import admin from "../../../../src/assets/images/admin.png"
import hide_family from "../../../../src/assets/images/hide.png"

import delete_member from "../../../../src/assets/images/delete_member.png"
import { callFlutterHandler } from "../../../FlutterHandler.js";
import { sendEventToFlutter } from "../../../../src/components/App/FamilyTree.js";
let currentStatus = []; // To store the current status
let relationStatus=[];
var loopcount=1
var has_order_changed=false
export function Card(props) {
  props = setupProps(props);
  const store = props.store;
  setupSvgDefs()
  return function ({ node, d }) {
    console.log(d)
    const currentURL = window.location.href.split('?')[0];
    if (!d || !d.data || !d.data.data) {
      return; 
    }
    let colorToUse = d.data.data.is_existing_member ? getNextAvailableColor(props.colors,d,props.existingMember) :  d.data.data.gender === 'M'|| d.data.data.gender === 'Male' ? props.male_color:props.female_color;
    colorToUse=d.data.authenticated && d.data.authenticated===true?"#509DB9":colorToUse;
    const el = document.createElementNS("http://www.w3.org/2000/svg", 'g'),
      gender_class = d.data.data.gender === 'M' ||d.data.data.gender === 'Male' ?

       'card-male' : d.data.data.gender === 'F'||d.data.data.gender === 'Female'? 'card-female' : 'card-genderless',
      stroke_color=d.data.data.gender === 'M'||d.data.data.gender === 'Male' ? '#7faae1':'#b873b2',
      authenticated_class = d.data.authenticated && d.data.authenticated===true? `${gender_class} card-authenticated` : gender_class,
      card_dim = props.card_dim,


      show_mini_tree = !isAllRelativeDisplayed(d, store.state.tree.data),
     // unknown_lbl = props.cardEditForm ? 'Add Spouse' : 'UNKNOWN',

      mini_tree = () => !d.data.to_add && show_mini_tree ? MiniTree({ d, card_dim }).template : '',
      card_body_outline = () => CardBodyOutline({ d, card_dim, is_new: d.data.to_add }).template,
      //card_body = () => !d.data.to_add ? CardBody({ d, card_dim, card_display: props.card_display }).template : CardBodyAddNew({ d, card_dim, card_add: props.cardEditForm, label: unknown_lbl }).template,
      card_body = () => !d.data.to_add ? CardBody({ d, card_dim, card_display: props.card_display,color:colorToUse,font_family:props.font_family,font_size:props.font_size,font_color:props.font_color,module:props.module }).template : '',
    
      card_image = () => !d.data.to_add ? CardImage({ d, image: d.data.data.profile_pic || null, card_dim, maleIcon: null, femaleIcon: null,is_living:d.data.data.is_living,adopted:d.data.data.adopted,divorced:d.data.data.divorced,is_admin:d.data.data.is_admin}).template : '',
      edit_icon = () => !d.data.to_add && props.cardEditForm ? PencilIcon({ card_dim, x: card_dim.w - 46, y: card_dim.h - 20 }).template : '',
      path_icon=() =>PathIcon({ d, card_dim, x: card_dim.w - 63, y: card_dim.h - 60 }).template,
      add_icon = () => !d.data.to_add && props.cardEditForm ? PlusIcon({ d, card_dim, x: card_dim.w - 20, y: card_dim.h - 21,color:stroke_color }).template : '',
      link_break_icon = () => LinkBreakIconWrapper({ d, card_dim })
      
      let tooltipHTML,nameTooltipHTML,optionsVisibilityStyle;
      if(props.member_count==1){
             tooltipHTML = `
              <foreignObject x="${card_dim.w / 2 + 105}" y="${-card_dim.h / 2 + 20}" width="195" height="60" style="z-index: 999999;">
                <div class="tooltip" style="background-color: #dcd0ff; padding: 10px; border-radius: 5px; border: 1px solid #ccc; font-size: 14px; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);opacity:1;">
                  <p style="margin: 0; color: black;">Click <b>+</b> icon to add relatives</p>
                <div style="position: absolute; top: 50%; left: -10px; transform: translateY(-50%); width: 0; height: 0; border-left: 10px solid #f1f1f1; border-top: 6px solid transparent; border-bottom: 6px solid transparent; box-shadow: -1px 1px 2px rgba(0,0,0,0.1);"></div>
                </div>
              </foreignObject>

               <foreignObject x="${card_dim.w / 2 -280}" y="${-card_dim.h / 2 -10}" width="195" height="60" style="z-index: 999999;">
                <div class="tooltip" style="background-color: #dcd0ff; padding: 10px; border-radius: 5px; border: 1px solid #ccc; font-size: 14px; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);opacity:1;">
                  <p style="margin: 0; color: black;">Click <b>profile pic</b> icon to edit member</p>
                <div style="position: absolute; top: 50%; left: -10px; transform: translateY(-50%); width: 0; height: 0; border-left: 10px solid #f1f1f1; border-top: 6px solid transparent; border-bottom: 6px solid transparent; box-shadow: -1px 1px 2px rgba(0,0,0,0.1);"></div>
                </div>
              </foreignObject>
            `;
             nameTooltipHTML = `
    <foreignObject x="${card_dim.w / 2-80}" y="${card_dim.h / 2-150}" width="200" height="60" style="z-index: 999999;">
      <div class="tooltip" style="background-color: #dcd0ff; padding: 10px; border-radius: 5px; border: 1px solid #ccc; font-size: 14px; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); opacity:1;">
        <p style="margin: 0; color: black;">Click <b>name</b> to expand member tree</p>
        <div style="position: absolute; top: -10px; left: 30px; width: 0; height: 0; border-left: 6px solid transparent; border-right: 6px solid transparent; border-bottom: 10px solid #ffe5b4;"></div>
      </div>
    </foreignObject>
  `;
  optionsVisibilityStyle = 'visibility: visible;';
     }
     else{
      tooltipHTML='';
      nameTooltipHTML='';
      optionsVisibilityStyle = 'visibility: hidden;';
     }
     const isSibling =store.state.siblingNodes? store.state.siblingNodes.includes(d.data.id):false; // Check if the member ID is in the siblings list
    // Conditionally set the display property based on the member's presence in the siblings list
    const displayStyle = isSibling ? 'inline' : 'none';
    //<g clip-path="url(#card_clip)">
    const displayCake = isBirthdayToday(d.data.data.dob) ? 'block' : 'none';


    el.innerHTML = (`
    <g class="card  ${authenticated_class}" data-id="${d.data.id}" data-cy="card">
    <g transform="translate(${-card_dim.w / 2}, ${-card_dim.h / 2})">
      ${props.mini_tree ? mini_tree() : ''}
      ${card_body_outline()}  
      <g>
        ${card_body()}
        ${card_image()}
        ${edit_icon()}
        ${add_icon()}
      </g>
      ${tooltipHTML}
      ${nameTooltipHTML}
      ${props.link_break ? link_break_icon() : ''}
      ${birthdayCake(displayCake,card_dim)}

      <foreignObject x="${card_dim.img_x +12}" y="${card_dim.img_y-10}" width="100" height="30">
        <span id="orderId_${d.data.id}" class="orderId" style="font-size: 16px; color: red; font-weight: bold; cursor: text;display: ${displayStyle};">
      ${d.data.data.order_id !== undefined && d.data.data.order_id !== null && d.data.data.order_id !== 0 ? d.data.data.order_id : ''}
        </span>
      </foreignObject>

      ${props.relationshipNavigator 
        ? `<image class="card_add_path" x="${card_dim.w / 2 - 100}" y="${-card_dim.h / 2 - 5}" width="50" height="50" href="${path_tracker}" />` 
        : ''}
        ${document.querySelector('[title="Disable Drag"]') 
          ? `<image class="card_hide_path" 
            x="${card_dim.w / 2 - 40}" 
            y="${-card_dim.h / 2 + 12}" 
            width="20" height="20" 
            href="${hide_family || ''}"
            cursor="pointer" 
            data-option="hide-family"
            />`
          : ''}
      </g>
  </g>
  <defs>
  <marker id="arrowhead" markerWidth="10" markerHeight="7" 
          refX="0" refY="3.5" orient="auto" fill="#444" style="position: absolute; ${optionsVisibilityStyle}">
    <polygon points="0 0, 10 3.5, 0 7" />
  </marker>
</defs>
<line class="connectorLine" x1="0" y1="${card_dim.h / 2 - 50}" 
      x2="0" y2="${card_dim.h / 2 - 95}" 
      stroke="#444" stroke-width="3" 
      marker-end="url(#arrowhead)" style="position: absolute; ${optionsVisibilityStyle}"/>

    `)
    setupListeners(el, d, store);

    return el
  }
  
function isBirthdayToday(dob) {
  if (!dob) return false;

  // Expected format: DD-MM-YYYY
  const parts = dob.split('-');
  if (parts.length !== 3) return false;

  const dobDay = parseInt(parts[0], 10);
  const dobMonth = parseInt(parts[1], 10); // 1-based

  const today = new Date();
  const todayDay = today.getDate();
  const todayMonth = today.getMonth() + 1; // JS months are 0-based

  return dobDay === todayDay && dobMonth === todayMonth;
}

function birthdayCake(displayStyle, card_dim) {
  return `
  <g class="birthday-cake"
     transform="
       translate(${card_dim.w / 2 + 10}, ${card_dim.h-12})
     "
     style="display:${displayStyle}; pointer-events:none;">

    <text
      x="0"
      y="0"
      text-anchor="middle"
      dominant-baseline="middle"
      font-size="28">
      🎂
    </text>

  </g>
  `;
}



// Function to get the next available color and mark it as used
function getNextAvailableColor(colorObj,d,existingMemberDict) {
  if(existingMemberDict && d.data.data.first_name in existingMemberDict){
    return existingMemberDict[d.data.data.first_name]
  }
  
  for (const [color, isUsed] of Object.entries(colorObj)) {
    if (!isUsed) {
      colorObj[color] = true;
      existingMemberDict[d.data.data.first_name]=color
      return color;
    }
  }
  for (const [color, isUsed] of Object.entries(colorObj)) {
    colorObj[color] = false;
    existingMemberDict[d.data.data.first_name]=color
    return color
  }
  // If no colors are available, return a default color or handle as needed
  existingMemberDict[d.data.data.first_name]='defaultColor'

  return 'defaultColor';
}
  function inviteMember(store, { card: el, d }) {
    // Get the current URL
    const currentURL = window.location.href;

    // Define a regular expression to match UUIDs
    const uuidRegex = /([0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12})/;

    // Use the regular expression to extract the UUID from the URL
    const current_user_match = currentURL.match(uuidRegex);
    let current_user = null;
    let member_id = null
    if (current_user_match) {
       current_user = current_user_match[0];
       member_id = d.data.id;

    } else {
      console.log('UUID not found in the current URL.');
    }
    const data = {
      "logged_user_id": current_user,
      "member_id": member_id
  };
    post("api/v1/invite-member" ,data);
  }

function findObjectById(family,searchId) {
  for (const obj of family.data) {
      if (obj.data.id === searchId) {
          return obj;
      }
  }
  return null;
}


// Recursive function to traverse the family relations
function frp(root, toFind, visited,tree,relation) {
    if (!root) {
        return null;
    }
    
    if (visited.has(root.id)) {
        return null;
    }
    visited.add(root.id); // Mark this ID as visited

    currentStatus.push(root); // Append the current member to the status list
    relationStatus.push(relation);
    // Check if the current member is the one we're looking for
    if (root.id === toFind) {
        return [currentStatus,relationStatus]; // Return the current path if found
    }

    // Explore the family relations
    const relations = ["father", "mother", "spouses", "siblings","children"];
    for (const relation of relations) {
        // Get the relation(s)
        if (root.rels[relation]) {
            const relationIds = root.rels[relation];
              if (Array.isArray(relationIds)) { // Check if it's an array
                  for (const relId of relationIds) {
                      const temp = findObjectById(tree,relId);
                      if(temp && temp.data){
                      const result = frp(temp.data, toFind, visited,tree,relation);
                      if (result) { // If we found the target, return the result
                          return result;
                      }
                    }
                  }
              } else { // If it's a single value
                  const temp = findObjectById(tree,relationIds);
                  if(temp && temp.data){
                  const result = frp(temp.data, toFind, visited,tree,relation);
                  if (result) { // If we found the target, return the result
                      return result;
                  }
                }
              }
        }
    }

    currentStatus.pop(); // Remove the last member as we backtrack
    relationStatus.pop();
    return null; // Explicitly return null if not found
}

function showToast(relationshipName,heading) {
  const toastContainer = document.getElementById("toast-container");
  const toastHeadingContainer = document.createElement("h4");
  toastHeadingContainer.textContent=heading;
  toastHeadingContainer.style.color = "#06749C"; // Set the text color
  toastHeadingContainer.style.textDecoration = "underline"; // Underline the text
  toastHeadingContainer.style.marginBottom = "10px"; // Optional: space below the heading
  // toastMessage.textContent = relationshipName; 
  toastContainer.innerHTML = ""; // Clear previous content
  const toastMessageContainer = document.createElement("p");
  toastMessageContainer.textContent= relationshipName
  toastContainer.appendChild(toastHeadingContainer); // Append the heading
  toastContainer.appendChild(toastMessageContainer); // Append the heading
  toastContainer.style.display = 'block';
  setTimeout(() => {
    toastContainer.style.opacity = 1; 
  }, 10);
  

  setTimeout(() => {
    toastContainer.style.opacity = 0;
    setTimeout(() => {
      toastContainer.textContent = "";
      toastHeadingContainer.textContent="";
      toastContainer.style.display = 'none';
    }, 500); 
  }, 10000);

}
function findPathFromMain(store, { card: el, d }){

  currentStatus = [];
  const main_card = document.querySelector('g.card-authenticated');
  const main_id_authenticated=main_card.getAttribute('data-id');
  const clicked_node = findObjectById(store.state.tree,d.data.id);
  const main_node=findObjectById(store.state.tree,main_id_authenticated);
  let member_result,relation_result,first_name_list;
  let final_toast_string="";
  let heading="Heading"   
  let relationshipPathNodes;
    if (main_node && clicked_node) {
        const visited = new Set();  // Initialize a set to track visited IDs
        if(main_node.y>clicked_node.y){
          [member_result,relation_result] = frp(main_node.data, clicked_node.data.id, visited,store.state.tree,"self");
        }
        else{
          [member_result,relation_result] = frp(clicked_node.data, main_node.data.id, visited,store.state.tree,"self");

        }
        let indices = [];
        for (let i = 0; i < relation_result.length - 1; i++) {
            if (relation_result[i] === "father" && relation_result[i + 1] === "spouses") {
                indices.push(i);
            }
        }

        // Sort indices in descending order to avoid shifting issues
        indices.sort((a, b) => b - a);

        // Remove elements from member_result based on indices
        for (let index of indices) {
            member_result.splice(index, 1);
            if(index+1<=relation_result.length){
              relation_result[index+1]="mother"
            }
            relation_result.splice(index, 1);
            
        }
        // console.log(member_result)
        if (member_result) {
            first_name_list=member_result.map(member => member.data.first_name)
            const final_name_list=member_result.map(member => member.data.first_name)
            relationshipPathNodes= member_result.map(member => member.id)
            store.relationshipPathNodes=relationshipPathNodes
            // toggleAllRels(store.getTree().data, false)
            // store.state.main_id=main_id_authenticated
            store.update.tree({tree_position: 'inherit'})
            relation_result=relation_result.map(relation => {
              return relation === "spouses" ? "spouse" : relation;});
            for (let i = 0; i < final_name_list.length-1; i++) {
              final_toast_string+=final_name_list[i]+"'s "+relation_result[i+1]+" >> "
            }
            final_toast_string=final_name_list[0]+" >> "+final_toast_string+final_name_list[final_name_list.length-1]
            heading=final_name_list[0]+"'s relationship with "+final_name_list[final_name_list.length-1]
            showToast(final_toast_string,heading);
            relationStatus=[]

        } else {
            console.log("Target not found.");
        }
    } else {
        console.log("Root not found.");
    }
}
  function editProfile(store, { card: el, d,isBefore:isBefore }) {
    const currentURL = window.location.href.split('?')[0];
    if(!currentURL.includes('/tree/') && !currentURL.includes('/sharetree/')){
    const logged_in_user_obj=JSON.parse(localStorage.getItem('userData'))
    const logged_in_user_id=logged_in_user_obj.user_profile.member_id
    const logged_in_user_super_user_status=logged_in_user_obj.user_profile.is_superuser
    const admin_status=logged_in_user_obj.user_profile.is_admin
    if (d.data.owner==logged_in_user_id || logged_in_user_super_user_status|| admin_status)
    {
      const BaseUrl=window.location.origin
      const member_id = d.data.id
      window.location.href = BaseUrl+"/"+member_id+"/edit-member";
    }
    else{
          if(!currentURL.includes('/sharetree/'))
            alert('You need to be a superuser or owner of the node in order to edit the member!')
      }
    }
    else
  {
    // callFlutterHandler('communicationname',{"event":"edit","member_id":d.data.id})
    //   if(isBefore){
    //   const url = `${currentURL}?event=edit&member_id=${d.data.id}`;
    //   window.location.href = url;
    // }
      // if (props?.isBefore) {
      sendEventToFlutter("edit", {"d":d,"isBefore":props.isBefore});
    // }
  }}
async function updateOrderIdAndRender(order_id_list) {
  console.log("New order:", order_id_list);

  order_id_list.forEach((memberId, index) => {
    const node = store.state.data.find(
      (m) => m.id === memberId || m.data?.old_id === memberId
    );
    if (node) {
      node.data.order_id = index + 1; 
    }
  });

  if (order_id_list.length > 0) {
    const firstMember = store.state.data.find(
      (m) => m.id === order_id_list[0] || m.data?.old_id === order_id_list[0]
    );

    if (firstMember) {
      const parentId = firstMember.rels.father || firstMember.rels.mother;

      if (parentId) {
        const parent = store.state.data.find(
          (m) => m.id === parentId || m.data?.old_id === parentId
        );

        if (parent) {
          parent.rels.children = order_id_list.filter((id) =>
            parent.rels.children.includes(id)
          );
        }
      }
    }
  }

  if (window.buildTreeFromFlutter) {
    window.buildTreeFromFlutter({ members: store.state.data });
  }

  return true;
}


  async function updateOrderId(order_id_list) {
    updateOrderIdAndRender(order_id_list)
    const response = await axiosInstance.post(
      `${API_BASE_URL}assign-sibling-order/`,
      {'order_id':order_id_list,"member_editor":props.loggedInMember},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    if(response){  
      console.log("response received!")
  }
  return true;
  }

  function openSiblingsPopup(siblings) {
    const popupContainer = document.getElementById('popup-container');
    if (popupContainer) {
      popupContainer.remove();
    }
  
    const popup = document.createElement('div');
    popup.id = "popup-container";
    popup.style.position = 'fixed';
    popup.style.top = '50%';
    popup.style.left = '50%';
    popup.style.transform = 'translate(-50%, -50%)';
    popup.style.backgroundColor = 'white';
    popup.style.padding = '20px';
    popup.style.border = '1px solid #ccc';
    popup.style.zIndex = '1000';
    popup.style.boxShadow = '0px 0px 10px rgba(0, 0, 0, 0.1)';
    popup.style.maxWidth = '400px';
    popup.style.width = '90%';
    popup.style.borderRadius = '10px';
  
    const title = document.createElement('h3');
    if (siblings.length === 0 || siblings.length === 1) {
      title.innerText = 'Member does not have any siblings!';
    } else {
      title.innerText = 'Arrange Siblings';
    }
    popup.appendChild(title);
  
    const siblingList = document.createElement('ul');
    siblingList.classList.add('ul-siblings-list');
    siblingList.style.padding = '0px';
    siblingList.style.margin = 0;
    siblingList.style.listStylePosition = "inside";
  
    siblings.forEach((sibling, index) => {
      const li = document.createElement('li');
      li.classList.add('siblings-list');
      li.style.display = "flex";
      li.style.alignItems = "center";
      li.style.justifyContent = "space-between";
      li.style.border = "1px solid #ccc";
      li.style.borderRadius = "6px";
      li.style.padding = "10px";
      li.style.margin = "10px 0";
      li.style.backgroundColor = "#f9f9f9";
  
      const span = document.createElement('span');
      span.classList.add('sibling-name');
      span.style.display = "inline-block";
      span.style.overflow = "hidden";
      span.style.textOverflow = "ellipsis";
      span.style.whiteSpace = "nowrap";
      span.style.width = "150px";
      span.style.color = "#3498db";
      span.innerText = sibling.name;
  
      const arrowGroup = document.createElement('div');
      arrowGroup.style.display = "flex";
      arrowGroup.style.flexDirection = "row";
      arrowGroup.style.gap = "5px";
  
      function createArrowButton(symbol, onClick) {
        const btn = document.createElement('button');
        btn.innerText = symbol;
        btn.onclick = onClick;
  
        btn.style.width = '32px';
        btn.style.height = '32px';
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        btn.style.border = '1px solid #ccc';
        btn.style.borderRadius = '6px';
        btn.style.backgroundColor = 'white';
        btn.style.cursor = 'pointer';
        btn.style.fontSize = '18px';
        btn.style.padding = '0';
        btn.style.color = '#0a6783';
        btn.addEventListener('mouseover', () => {
          btn.style.backgroundColor = '#f0f0f0';
        });
        btn.addEventListener('mouseout', () => {
          btn.style.backgroundColor = 'white';
        });
  
        return btn;
      }
  
      const moveUpButton = createArrowButton('▲', () => moveSibling(index, 'up'));
      const moveDownButton = createArrowButton('▼', () => moveSibling(index, 'down'));
  
      if (index === 0) moveUpButton.style.visibility = 'hidden';
      if (index === siblings.length - 1) moveDownButton.style.visibility = 'hidden';
  
      arrowGroup.appendChild(moveUpButton);
      arrowGroup.appendChild(moveDownButton);
  
      li.setAttribute('data-member-id', sibling.id);
      li.appendChild(span);
      li.appendChild(arrowGroup);
      siblingList.appendChild(li);
    });
  
    // Make list scrollable
    const scrollContainer = document.createElement('div');
    scrollContainer.style.maxHeight = '300px';
    scrollContainer.style.overflowY = 'auto';
    scrollContainer.style.marginTop = '10px';
    scrollContainer.appendChild(siblingList);
    popup.appendChild(scrollContainer);
  
    const closeButton = document.createElement('button');
    closeButton.innerText = 'Save';
    closeButton.style.marginRight = '10px';
    closeButton.addEventListener('click', (e) => {
      const siblingsListItems = document.querySelectorAll('li.siblings-list');
      const memberIds = Array.from(siblingsListItems).map(li => li.getAttribute('data-member-id'));
  
      if (has_order_changed) {
        has_order_changed = false;
        closeButton.innerText = 'Saving..';
        document.body.removeChild(popup);
        updateOrderId(memberIds)
          .then(result => {
            console.log("done")
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        document.body.removeChild(popup);
      }
    });
  
    const cancelButton = document.createElement('button');
    cancelButton.innerText = 'Cancel';
    cancelButton.addEventListener('click', (e) => {
      document.body.removeChild(popup);
    });
  
    if (siblings.length !== 0 && siblings.length !== 1) {
      popup.appendChild(closeButton);
    }
    popup.appendChild(cancelButton);
    document.body.appendChild(popup);
  
    // Reordering function
    function moveSibling(index, direction) {
      has_order_changed = true;
      const temp = [...siblings];
      const sibling = temp.splice(index, 1)[0];
  
      if (direction === 'up' && index > 0) {
        temp.splice(index - 1, 0, sibling);
      } else if (direction === 'down' && index < siblings.length - 1) {
        temp.splice(index + 1, 0, sibling);
      }
  
      openSiblingsPopup(temp);
    }
  }
function hideSubtree(node, tree, visited = new Set()) {
  if (!node || visited.has(node.data.id)) return;
  visited.add(node.data.id);
const nodeId = node?.data?.id ?? node?.id;

const actualNode = store.state.tree.data_stash.find(n => n.id === nodeId);
  if (actualNode) {
    actualNode.data.hidden = true;
  }

  const children = actualNode?.children || node.children || [];
  children.forEach(child => hideSubtree(child, tree, visited));
  const spouseIds = actualNode?.data.rels?.spouses || node.data.rels?.spouses || [];
  spouseIds.forEach(spouseId => {
    const spouseNode = store.state.tree.data_stash.find(n => n.id === spouseId);
    if (spouseNode) {
      hideSubtree(spouseNode, tree, visited);

      const spouseChildren = spouseNode.children || [];
      spouseChildren.forEach(child => hideSubtree(child, tree, visited));
    }
  });
}


  function highlightMember(element){
    const parentElement = element.parentElement;
    const rectElement=parentElement.querySelector('rect.card-body-rect');
    let gTag = document.querySelector('g.card-authenticated');
    if (gTag) {
        gTag.classList.remove('card-authenticated');
        const isMale = gTag.classList.contains('card-male') || gTag.classList.contains('card-genderless');
        const cardBodyRect = gTag.querySelector('rect.card-body-rect');
        if(cardBodyRect){
          if (isMale) {
            cardBodyRect.style.fill = '#dde8fe';
          }
          else{
            cardBodyRect.style.fill = '#fae6ff';
          }
          const previousCrossIcon = gTag.querySelector('.crossIcon');
          if (previousCrossIcon) {
              previousCrossIcon.style.visibility = 'hidden';
          }
        }
  }
     rectElement.style.fill = "#509DB9";
    const parentGroup = rectElement.closest('.card');
    if(parentGroup) {
      parentGroup.classList.add('card-authenticated');
    //  const currentCrossIcon = parentGroup.querySelector('.crossIcon');
    // if (currentCrossIcon) {
    //     currentCrossIcon.style.visibility = 'visible';
    // }
  }
  }



  function setupListeners(el, d, store) {
    // Add a click event listener to the .card-body element
    const cardBody = el.querySelector(".card-body");

    if (cardBody) {
      cardBody.addEventListener("click", (e) => {
        let target = e.target;
        if (target.classList.contains("invite")) {
          inviteMember(store, { card: el, d });
        }
        if (target.classList.contains("title")) {
          cardChangeMain(store, { card: el, d }) 
        }
      });
    }
   
function showLockedTooltip(el, lockedByUser) {
  // remove old tooltip if exists
  const oldTooltip = el.querySelector(".locked_tooltip");
  if (oldTooltip) oldTooltip.remove();

  const card_dim = { w: 200, h: 100 }; // adjust to your actual card size

  const tooltipHTML = `
    <foreignObject x="${card_dim.w / 2 }" y="${-card_dim.h / 2 }" 
        width="195" height="60" class="locked_tooltip" style="z-index:999999;">
      <div style="background-color:#ffd6d6; padding:10px; border-radius:5px; 
          border:1px solid #f5bcbc; font-size:14px; color:#333; 
          box-shadow:0px 4px 6px rgba(0,0,0,0.1); opacity:1; position:relative;">
        <p style="margin:0;"> <b>${lockedByUser} is adding members!</p>
        <div style="position:absolute; top:50%; left:-10px; transform:translateY(-50%);
            width:0; height:0; border-left:10px solid #ffd6d6; 
            border-top:6px solid transparent; border-bottom:6px solid transparent;
            box-shadow:-1px 1px 2px rgba(0,0,0,0.1);"></div>
      </div>
    </foreignObject>
  `;

  // append tooltip inside the SVG group for this card
  el.insertAdjacentHTML("beforeend", tooltipHTML);

  // remove tooltip after a short delay
  setTimeout(() => {
    const t = el.querySelector(".locked_tooltip");
    if (t) t.remove();
  }, 2000);
}
    function sortMembers(members) {
      // Check if all members have a valid non-zero order_id
      const allHaveOrderId = members.every(member => member.order_id && member.order_id !== 0);
    
      if (allHaveOrderId) {
        // Sort by order_id if all members have non-zero order_id
        return members.sort((a, b) => a.order_id - b.order_id);
      }
    
      const anyHaveDob = members.some(member => member.dob);

      if (anyHaveDob) {
        // Sort by dob if any member has dob, members without dob go to the bottom
        return members.sort((a, b) => {
          const dobA = a.dob ? new Date(a.dob) : null;
          const dobB = b.dob ? new Date(b.dob) : null;
          
          if (dobA && dobB) {
            return dobA - dobB; // Sort by dob if both members have dob
          } else if (dobA) {
            return -1; // Place members with dob above those without
          } else {
            return 1; // Place members without dob below
          }
        });
      }
    
      // Fallback: Sort by date_joined if order_id or dob cannot be used
      return members.sort((a, b) => new Date(a.date_joined) - new Date(b.date_joined));
    }
    if(loopcount==1){
      loopcount=loopcount+1
    document.addEventListener('click', function(event) {
      try {
        if (event.target.classList.contains('move-up-btn')) {
          console.log("inside!") // If true, exit the function (i.e., do nothing)
        }
        else{
          const allCards = document.querySelectorAll('.card_cont');

          allCards.forEach(card => {
        // Set opacity to 0.2 for all cards except the current one
          card.style.opacity = '1';
          card.style.pointerEvents='auto'
          })
          const allCardOptions = document.querySelectorAll('.card-options');
          // Check if the clicked element is outside of the card-options element
          allCardOptions.forEach(cardOptions => {
              cardOptions.style.visibility = 'hidden';
          });
        }
      } catch (error) {
        console.error('Error while hiding card-options:', error);
      }
    });
  }
    let p;

    // p = el.querySelector(".card_image")
    // // if (p) p.addEventListener("click", (e) => {e.stopPropagation(); editProfile(store, { card: el, d }) })
    // if (p) p.addEventListener("click", (e) => {e.stopPropagation(); alert("I am here..") })

    // p = el.querySelector(".genderless-icon")
    // if (p) p.addEventListener("click", (e) => { e.stopPropagation(); editProfile(store, { card: el, d }) })

    const genderlessIcon = el.querySelector(".genderless-icon");
    const cardImage = el.querySelector(".card_image");
    const handleClick = (e) => { e.stopPropagation();  
      const currentURL = window.location.href.split('?')[0];
      if (currentURL.includes('/sharetree/')) {

        document.querySelectorAll('[id^="about-me-popup-"]').forEach(p => {
          p.style.visibility = 'hidden';
        });

        const popup = el.querySelector(`#about-me-popup-${d.data.id}`);
        if (popup) popup.style.visibility = 'visible';
      }

        else{
          props.imageClicked({ d,isBefore:props.isBefore })
          // Find the closest <g> tag that has 'card' as one of its classes
          const closestCardGTag = e.target.closest('g.card');
          let dataId;
          // Check if the element exists and retrieve the 'data-id' attribute
          if (closestCardGTag) {
               dataId = closestCardGTag.getAttribute('data-id');
              console.log("Data ID:", dataId);
          }
          // Assuming store.state.tree.data is an array of nodes
          const nodes = store.state.tree.data;

          // Find the node with the matching id
          const foundNode = nodes.find(node => node.data.id === dataId);

          if (foundNode) {
              console.log("Found Node:", foundNode);
          } else {
              console.log("Node with ID", dataId, "not found.");
          }
          let familyChartElement=document.getElementById("FamilyChart")
          let svg = familyChartElement.querySelector('svg');
          mainToMiddle({datum: foundNode, svg, svg_dim: svg.getBoundingClientRect(), scale:1,transition_time: 2000})
          const currentCard = e.target.closest('.card_cont');

      // Get all elements with class 'card_cont' except the current one
      const allCards = document.querySelectorAll('.card_cont');

      // allCards.forEach(card => {
      //   if (card !== currentCard) {
      //     // Set opacity to 0.2 for all cards except the current one
      //     card.style.opacity = '0.2';
      //     card.style.pointerEvents = 'none'; // Ignore pointer events on the rect
      //   } else {
      //     // Set the current card's opacity back to 1 or any value you need
      //     card.style.opacity = '1';
      //   }
      // });

        }
  }
  if (genderlessIcon) genderlessIcon.addEventListener("click", handleClick);
  if (cardImage) cardImage.addEventListener("click", handleClick);
    let hideBtn = el.querySelector(".card_hide_path");
    if (hideBtn) {
      hideBtn.addEventListener("click", (e) => {
        hideSubtree(d, store.state.tree);
        store.update.tree({ tree_position: "inherit" });
        e.stopPropagation();
      });
    }
    p = el.querySelector(".card_family_tree")
    if (p) p.addEventListener("click", (e) => {if(props.family_id && props.family_id=='8f909b74-c656-4946-b08a-19068f76c2f0'){let url=window.location.href;url = url.replace(/(tree\/)([^\/]+)(\/.*)/, `$1${d.data.id}$3`);window.location.href =url;}else{console.log("none")}; e.stopPropagation(); cardChangeMain(store, { card: el, d }) })

    p = el.querySelector(".card_edit")
    if (p && props.cardEditForm) p.addEventListener("click", (e) => { e.stopPropagation(); cardEdit(store, { card: el, d, cardEditForm: props.cardEditForm,isBefore:props.isBefore }) })

    p = el.querySelector(".card_add")
    if (p && props.cardEditForm) p.addEventListener("click", (e) => { e.stopPropagation(); cardEdit(store, { card: el, d, cardEditForm: props.cardEditForm,isBefore:props.isBefore }) })

    p = el.querySelector(".card_add_relative")
    if (p) p.addEventListener("click", (e) => {
      e.stopPropagation();
       
      const { isLocked, lockedBy } = props.lockRef.current;

      if (isLocked) {
        showLockedTooltip(el, lockedBy);
        return;
      }
      props.addRelative({d,isBefore:props.isBefore})
    })

    p = el.querySelector(".card_break_link")
    if (p) p.addEventListener("click", (e) => {e.stopPropagation(); cardShowHideRels(store, { card: el, d }) })

    p = el.querySelector(".card_add_path")
    if (p) p.addEventListener("click", (e) => { e.stopPropagation(); findPathFromMain(store, { card: el, d }) })

    p = el.querySelector(".card-body-rect")
    if (p) p.addEventListener("click", (e) => {e.stopPropagation();highlightMember(p)})
      
    p = el.querySelector(".card_remove_icon")
    if (p) p.addEventListener("click", (e) => {e.stopPropagation();props.deleteMember({d,isBefore:props.isBefore})})

      p = el.querySelector(".card-options");
      if (p) {
        p.addEventListener("click", (e) => {
          e.stopPropagation();
          // Ensure the clicked element or its parent <g> has the data-option attribute
          let clickedOption = e.target;
      
          // Traverse up the DOM tree to ensure we're checking the parent if the click is on the <rect>
          while (clickedOption && !clickedOption.getAttribute("data-option")) {
            clickedOption = clickedOption.parentElement;
          }
      
          // Now clickedOption should be the <g> or <text> with the data-option attribute
          const option = clickedOption ? clickedOption.getAttribute("data-option") : null;
      
          if (option) {
            // Option was clicked, handle it
            switch (option) {
              case 'edit':
                editProfile(store, { card: el, d,isBefore:props.isBefore });
                break;
              case 'rearrange':
                let foundNames = [];
                const nodes_list = store.state.tree.data;

                if (d.data && d.data.rels) {
                  // Add siblings
                  d.data.rels.siblings.forEach((sibling) => {
                    const node = nodes_list.find((n) => n.data.id === sibling);
                    if (node) {
                      foundNames.push({
                        name: node.data.data.first_name,
                        id: sibling,
                        order_id: node.data.data.order_id,
                        dob: node.data.data.dob,
                        date_joined: node.data.data.date_joined,
                      });
                    }
                  });

                  // Add main node
                  const main_node = nodes_list.find((n) => n.data.id === d.data.id);
                  if (main_node) {
                    foundNames.push({
                      name: main_node.data.data.first_name,
                      id: d.data.id,
                      order_id: main_node.data.data.order_id,
                      dob: main_node.data.data.dob,
                      date_joined: main_node.data.data.date_joined,
                    });
                  }

                  //  Deduplicate using id
                  foundNames = Object.values(
                    foundNames.reduce((acc, item) => {
                      acc[item.id] = item; 
                      return acc;
                    }, {})
                  );

                  // Sort + show popup
                  foundNames = sortMembers(foundNames);
                  openSiblingsPopup(foundNames);
                } else {
                  openSiblingsPopup([]);
                }

                break;
              case 'delete':
                props.deleteMember({ d,isBefore:props.isBefore });
                break;
              case 'admin':
                props.makeAdmin({ d,isBefore:props.isBefore });
                break;
            }
          }
        });
      }
      

  }


  
  function setupSvgDefs() {
    if (props.svg.querySelector("defs#f3CardDef")) return
    const card_dim = props.card_dim
    props.svg.insertAdjacentHTML('afterbegin', (`
      <defs id="f3CardDef">
        <linearGradient id="fadeGrad">
          <stop offset="0.9" stop-color="white" stop-opacity="0"/>
          <stop offset=".91" stop-color="white" stop-opacity=".5"/>
          <stop offset="1" stop-color="white" stop-opacity="1"/>
        </linearGradient>
        <mask id="fade" maskContentUnits="objectBoundingBox"><rect width="1" height="1" fill="url(#fadeGrad)"/></mask>
        <clipPath id="card_clip"><path d="${curvedRectPath({ w: card_dim.w, h: card_dim.h }, 5)}"></clipPath>
        <clipPath id="card_text_clip"><rect width="${card_dim.w - card_dim.text_x - 10}" height="${card_dim.h - 10}"></rect></clipPath>
        <clipPath id="card_image_clip"><path d="M0,0 Q 0,0 0,0 H${card_dim.img_w} V${card_dim.img_h} H0 Q 0,${card_dim.img_h} 0,${card_dim.img_h} z"></clipPath>
        <clipPath id="card_image_clip_curved"><path d="${curvedRectPath({ w: card_dim.img_w, h: card_dim.img_h }, 5, ['rx', 'ry'])}"></clipPath>
        <clipPath id="card_image_clip_curved1"><circle cx="30" cy="30" r="30" /> </clipPath>
      </defs>
    `))


    function curvedRectPath(dim, curve, no_curve_corners) {
      const { w, h } = dim,
        c = curve,
        ncc = no_curve_corners || [],
        ncc_check = (corner) => ncc.includes(corner),
        lx = ncc_check('lx') ? `M0,0` : `M0,${c} Q 0,0 5,0`,
        rx = ncc_check('rx') ? `H${w}` : `H${w - c} Q ${w},0 ${w},5`,
        ry = ncc_check('ry') ? `V${h}` : `V${h - c} Q ${w},${h} ${w - c},${h}`,
        ly = ncc_check('ly') ? `H0` : `H${c} Q 0,${h} 0,${h - c}`

      return (`${lx} ${rx} ${ry} ${ly} z`)
    }
  }

  function setupProps(props) {
    const default_props = {
      mini_tree: true,
      link_break: true,
      card_dim: { w: 220, h: 70, text_x: 75, text_y: 15, img_w: 60, img_h: 60, img_x: 5, img_y: 5 }
    }
    if (!props) props = {}
    for (const k in default_props) {
      if (typeof props[k] === 'undefined') props[k] = default_props[k]
    }
    return props
  }
  
}
